import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SalesCreditNoteRegisterForm from '../components/SalesCreditNoteRegisterForm';
import { useCreateSalesCreditNoteRegisterHandler } from '../dataHandlers/createSalesCreditNoteRegisterHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_SALE_REGISTER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function CreateSalesCreditNoteRegisterPage() {
  const { salesInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(salesInvoiceRegister?.pages?.create_title_credit_note ?? 'Create Sales Credit Note Register Entry');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  useEffect(() => {
    if (loading) return;
    if (!hasEInvoicePermission(CREATE_SALE_REGISTER)) {
      showActionDeniedSnackbar();
      navigate('/sales-invoice-register?tab=credit-notes', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  const onRegisterCreated = () => {
    navigate('/sales-invoice-register?tab=credit-notes');
  };

  const { onSubmit, error, isPending } = useCreateSalesCreditNoteRegisterHandler({ onSuccess: onRegisterCreated });

  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const onSaveForm = (data) => {
    setIsSubmitting(true);
    onSubmit(data);
  };

  const onCancel = () => {
    navigate('/sales-invoice-register?tab=credit-notes', { replace: true });
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SalesCreditNoteRegisterForm
        initialData={{}}
        onSubmit={onSaveForm}
        onCancel={onCancel}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
